module.exports = __webpack_public_path__ + "static/jodha-9491070873dffd4443cd771d6f2db4c5.jpg";